function Solution() {
  const features = [
    {
      emoji: "🔥",
      title: "Жесткие приоритеты",
      description: "Топ-3 задачи, которые принесут 80% денег.",
    },
    {
      emoji: "📊",
      title: "Аналитика энергии",
      description: "Увидишь, куда уходит ресурс.",
    },
    {
      emoji: "💰",
      title: "Фокус на деньгах",
      description: "Каждая задача привязана к цене.",
    },
  ]

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white fade-on-scroll opacity-0">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center text-black mb-6 sm:mb-8 uppercase">
          ПЛАНЕР НАМЕРЕНИЙ — ТВОЙ ЛИЧНЫЙ БИЗНЕС-АДМИНИСТРАТОР.
        </h2>

        <p className="text-lg sm:text-xl text-gray-700 text-center max-w-4xl mx-auto mb-12 sm:mb-16 leading-relaxed">
          Забудьте про "списки задач". Это детский сад. "Планер Намерений" — это рабочая тетрадь дисциплины. 
          Это файл Excel, который каждый день будет задавать тебе правильные вопросы и фиксировать результат.
        </p>

        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-gray-50 p-6 sm:p-8 rounded-lg text-center hover:shadow-lg transition-shadow duration-200 border border-gray-200"
            >
              <div className="text-5xl sm:text-6xl mb-4">{feature.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-black mb-3">
                {feature.title}
              </h3>
              <p className="text-base sm:text-lg text-gray-600">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* Дополнительные изображения */}
        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 mt-12 sm:mt-16">
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://static.lumi.new/24/24d1f8d0cbfc365a84a62dde26e5cd1a.webp"
              alt="Планер намерений - скриншот 1"
              className="w-full h-auto rounded-lg shadow-xl border-2 border-gray-300 transition-transform duration-300 hover:scale-110 cursor-pointer"
            />
          </div>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://static.lumi.new/material/0e/0e9158a1e8ec9c3408766bc6b8d5878e.png"
              alt="Планер намерений - скриншот 2"
              className="w-full h-auto rounded-lg shadow-xl border-2 border-gray-300 transition-transform duration-300 hover:scale-110 cursor-pointer"
            />
          </div>
          <div className="overflow-hidden rounded-lg">
            <img
              src="https://static.lumi.new/material/31/3170899823cf02963487f0edf1347b16.png"
              alt="Планер намерений - скриншот 3"
              className="w-full h-auto rounded-lg shadow-xl border-2 border-gray-300 transition-transform duration-300 hover:scale-110 cursor-pointer"
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Solution
